import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { DeviceMobile } from "@phosphor-icons/react";

export default function LoginPage() {
  const { login, formatApiError } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(email, password);
      toast.success("Welcome back");
      if (user.role === "hotel_partner") nav("/partner/hotels");
      else if (user.role === "room_partner") nav("/partner/rooms");
      else if (user.role === "admin") nav("/admin");
      else nav("/");
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-24">
      <p className="text-xs tracking-[0.3em] uppercase text-gold mb-3">Welcome back</p>
      <h1 className="font-serif text-4xl text-midnight mb-8">Sign in to Zyro</h1>
      <form onSubmit={submit} className="space-y-5" data-testid="login-form">
        <div>
          <label className="text-xs tracking-widest uppercase text-neutral-500 block mb-2">Email</label>
          <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email" placeholder="you@example.com" />
        </div>
        <div>
          <label className="text-xs tracking-widest uppercase text-neutral-500 block mb-2">Password</label>
          <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password" placeholder="••••••••" />
        </div>
        <Button type="submit" disabled={loading} className="w-full bg-midnight hover:bg-midnight-hover text-bone py-6" data-testid="login-submit-btn">
          {loading ? "Signing in..." : "Sign In"}
        </Button>
        <div className="text-right">
          <Link to="/forgot-password" className="text-xs text-neutral-500 hover:text-gold underline" data-testid="forgot-password-link">
            Forgot password?
          </Link>
        </div>
      </form>

      <Link
        to="/otp-login"
        className="mt-4 flex items-center justify-center gap-2 py-3 rounded-full border border-black/10 text-midnight hover:bg-stone transition-colors text-sm"
        data-testid="otp-login-link"
      >
        <DeviceMobile size={18} weight="duotone" className="text-gold" />
        Sign in with mobile OTP
      </Link>

      <p className="text-sm text-neutral-600 mt-6">
        New here?{" "}
        <Link to="/register" className="text-midnight underline hover:text-gold" data-testid="switch-to-register">
          Create an account
        </Link>
      </p>
    </div>
  );
}
